module.exports = __webpack_public_path__ + "static/media/logo2-dif-2024.04e885f8.jpeg";